import React, { useEffect, useState } from 'react'

import './header.css'
import logo from '../assets/images/dashboard/lepton-icono.png'
import { userSections, adminSections } from './sideNav'

const Header = ({ activeSection, menuCollapsed, showMovilMenu, setShowMovilMenu, userInfo, isDarkMode, setIsDarkMode, apiUserInfo }) => {
    const [isMenuCollapsed, setIsMenuCollapsed] = useState(false);
    const [userName, setUserName] = useState('');
    const [userType, setUserType] = useState('');

    const sections = apiUserInfo.type === 'admin' ? adminSections : userSections;

    const toggleMenuCollapsed = () => {
        const newMenuCollapsedState = !isMenuCollapsed;
        setIsMenuCollapsed(newMenuCollapsedState);
        menuCollapsed(newMenuCollapsedState);
    };

    useEffect(() => {
        if (userInfo?.user_info) {
            setUserName(userInfo.user_info.title);
        }
    }, [userInfo]);

    useEffect(() => {
        if (apiUserInfo) {
            setUserType(apiUserInfo.type);
        }
    }, [apiUserInfo]);

    return (
        <header>
            <div className='header_content'>
                <div className={`header_logo_container ${isMenuCollapsed ? 'collapsed' : ''}`}>
                    <img className='logo' src={logo} alt='LeptónCheck' />
                    <h2 className='logo_text'>Leptón<span className='primary'>Check</span></h2>
                    <button onClick={toggleMenuCollapsed} className='menu_button'>
                        <span className='material-symbols-rounded'>
                            menu_open
                        </span>
                    </button>
                </div>
                <button onClick={() => setShowMovilMenu(true)} className='menu_button movil_menu_button'>
                    <span className='material-symbols-rounded'>
                        menu
                    </span>
                </button>
                <h1 className='header_title'>
                    {sections.flat().find((section) => section.label?.toLowerCase() === activeSection?.toLowerCase())?.title || ''}
                </h1>
                <div className='header_info_container'>
                    <div className='theme_mode_buttons' onClick={() => setIsDarkMode(!isDarkMode)}>
                        <span className={`material-symbols-rounded ${isDarkMode ? '' : 'active'}`}>
                            light_mode
                        </span>
                        <span className={`material-symbols-rounded ${isDarkMode ? 'active' : ''}`}>
                            dark_mode
                        </span>
                    </div>
                    <div className='header_profile_container'>
                        <div className='info'>
                            <span>Hola, <b>{userName}</b></span>
                            <small className='text-muted' style={{ display: 'block' }}>{userType === 'admin' ? 'Administrador' : 'Usuario'}</small>
                        </div>
                        <div className='profile-photo'>
                            <span className="material-symbols-rounded">person_outline</span>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header